import Error404Page from './Error404Page';
import { authModules } from 'app/auth';

const Error404PageConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: authModules.openforall,
	routes: [
		{
			path: 'error404',
			element: <Error404Page />
		}
	]
};

export default Error404PageConfig;
